import React, { Component } from 'react'
import { connect } from 'react-redux'
import { buttonColor, onControlClick, listOnSelect } from '../../JS/setColors'
import {
    sendCommand, sendACCommand,
    TempChange, setPowerSwitch, setEcoMode,
    VDAStatusApi, setSelectedZone, restoreValue
} from '../../action/roomControlAction'
import {
    ACPower, setTempOfAC, setFanSpeedToLow,
    setFanSpeedToMedium, setFanSpeedToHigh,
    setFanSpeedToAuto, ecoMode, decrementTemp,
    incrementTemp, fanSpeedID, setFanSpeedToggle,
    zoneName
} from '../../config/constant'
import { popupOpenClose } from '../../action/action'
import SelectZoneScreen from './selectZoneScreen'

class ACControl extends Component {
    constructor(props) {
        super(props);
        this.state = {
            powerON: this.props.powerSwitch,
            mode: this.props.ecoMode,
            fanSpeed: this.props.currentFanSpeed,
            maxTemp: null,
            SessionToken: localStorage.getItem("GuestJourneySessionToken")
        }
    }

    componentDidMount() {
        buttonColor(this.props.menuColor);//controls-ac
        onControlClick(this.props.currentFanSpeed, "fanSpeed", this.props.menuColor);
    }

    componentDidUpdate(preProps) {
        listOnSelect(this.props.menuColor);
        if (this.props.powerSwitch !== preProps.powerSwitch) {
            this.setState({
                powerON: this.props.powerSwitch,
            })
        }
        if (this.props.currentFanSpeed !== preProps.currentFanSpeed) {
            onControlClick(this.props.currentFanSpeed, "fanSpeed", this.props.menuColor);
            this.setState({
                fanSpeed: this.props.currentFanSpeed,
            })
        }
    }
    VDAStatusCallBack = (status, button) => {
    }

    VDAApiCall = () => {
        //we have set this time out to make sure that we hit the status API after we hit the sendCommand
        window.setTimeout(() => {
            //console.log("this.state.SessionToken", this.state.SessionToken);
            this.props.VDAStatusApi(
                this.state.SessionToken, this.props.guestDetail,
                this.VDAStatusCallBack, zoneName
            );
        }, 3000);
    }
    buttonClick = (id, mode) => {
        let Temprature
        onControlClick(id, mode, this.props.menuColor);
        if (mode === "tempControl" && this.props.currentACTemp !== 999 && this.props.selectedZone.zoneId && this.state.powerON === "ON") {
            if (id === "cooler") {
                if (this.props.celciusMin) {
                    if (this.props.currentACTemp > this.props.celciusMin) {
                        Temprature = this.props.currentACTemp - 1
                        this.props.TempChange("dec", Temprature);
                        this.props.sendACCommand(
                            decrementTemp, Temprature, "dec", this.props.guestDetail,
                            this.props.selectedZone.zoneId);
                        //this.VDAApiCall();
                    } else {
                        this.props.popupOpenClose(true, `Temprature can't be less than ${this.props.celciusMin}.`);
                    }
                } else {
                    this.props.popupOpenClose(true, `Sorry, can't change temperature.`);
                }
            } else if (id === "warmer") {
                if (this.props.celciusMax) {
                    if (this.props.currentACTemp < this.props.celciusMax) {
                        Temprature = this.props.currentACTemp + 1
                        this.props.TempChange("inc", Temprature);
                        this.props.sendACCommand(incrementTemp, Temprature, "inc", this.props.guestDetail, this.props.selectedZone.zoneId);
                        //this.VDAApiCall();
                    } else {
                        this.props.popupOpenClose(true, `Temprature can't be more than ${this.props.celciusMax}.`);
                    }
                } else {
                    this.props.popupOpenClose(true, `Sorry, can't change temperature.`);
                }
            }
        }

        // if (mode === "mode") {
        //     switch (id) {
        //         case 'EcoMode':
        //             this.setState({ mode: "EcoMode" });
        //             break;
        //         case 'fanOnly':
        //             this.setState({ mode: "fanOnly" })
        //             break;
        //         case 'fanFixed':
        //             this.setState({ mode: "fanFixed" })
        //             break;
        //         case 'fanAuto':
        //             this.setState({ mode: "fanAuto" })
        //             break;
        //         case 'fanOff':
        //             this.setState({ mode: "fanOff" })
        //             break;
        //         default:
        //             console.log("never going to happen");
        //             break;
        //     }
        // } else if (mode === "fanSpeed") {
        //     let action, button;
        //     switch (id) {
        //         case 'FAN_SPEED_AUTO':
        //             this.setState({ fanSpeed: "FAN_SPEED_AUTO" });
        //             button = "FAN_SPEED_AUTO"
        //             action = setFanSpeedToAuto
        //             break;
        //         case 'FAN_SPEED_LOW':
        //             this.setState({ fanSpeed: "FAN_SPEED_LOW" });
        //             button = "FAN_SPEED_LOW"
        //             action = setFanSpeedToLow
        //             break;
        //         case 'FAN_SPEED_MED':
        //             this.setState({ fanSpeed: "FAN_SPEED_MED" });
        //             button = "FAN_SPEED_MED"
        //             action = setFanSpeedToMedium
        //             break;
        //         case 'FAN_SPEED_HIGH':
        //             this.setState({ fanSpeed: "FAN_SPEED_HIGH" });
        //             button = "FAN_SPEED_HIGH"
        //             action = setFanSpeedToHigh
        //             break;
        //         default:
        //             console.log("never going to happen");
        //             action = null
        //             break;
        //     }
        //     if (action) {
        //         this.props.sendCommand(action, this.props.guestDetail, "fanSpeed", this.CommandCallBack, button);
        //     }
        // }
    }


    CommandCallBack = (section, status) => {
        console.log("API callback")
        if (section === "power") {
            if (status) {
                if (this.props.powerSwitch === "ON") {
                    this.props.setPowerSwitch("OFF");
                } else {
                    this.props.setPowerSwitch("ON");
                }
            } else {
                if (this.props.powerSwitch === "ON") {
                    document.getElementById("ac-power-switch").checked = true
                    console.log("API faild with ON");
                } else {
                    document.getElementById("ac-power-switch").checked = false
                    console.log("API faild with OFF");
                }
            }
        } else if (section === "fanSpeed") {
            if (!status) {
                this.setState({ fanSpeed: this.props.currentFanSpeed });
                if (!this.props.currentFanSpeed) {
                    onControlClick(null, section, this.props.menuColor);
                }
            }
        } else if (section === "ecoMode") {
            if (status) {
                this.props.setEcoMode(this.state.mode);
            } else {
                // this.setState({ mode: this.props.ecoMode });
            }
        }
    }

    ACPowerSwitch = () => {
        if (this.props.selectedZone.zoneId) {
            if (this.state.powerON) {
                if (this.props.powerSwitch === "ON") {
                    console.log("ACPowerSwitch OFF");
                    this.setState({ powerON: "OFF" });
                } else {
                    console.log("ACPowerSwitch ON");
                    this.setState({ powerON: "ON" });
                }
                this.props.sendCommand(
                    ACPower, this.props.guestDetail, "power",
                    this.CommandCallBack, null, this.props.selectedZone.zoneId
                );
                //this.VDAApiCall();
            }
        }
    }

    ecoButtonClick = (id, mode) => {
        if (this.props.selectedZone.zoneId) {
            if (this.props.ecoMode) {
                if (this.state.mode === "EcoMode") {
                    this.setState({ mode: null });
                } else {
                    onControlClick(id, mode, this.props.menuColor);
                    this.setState({ mode: "EcoMode" });
                }
                this.props.sendCommand(
                    ecoMode, this.props.guestDetail, "ecoMode",
                    this.CommandCallBack, null, this.props.selectedZone.zoneId
                );
                //this.VDAApiCall();
            }
        }
    }
    changeFanSpeed = () => {
        let speed = null
        if (this.props.selectedZone.zoneId) {
            if (this.state.fanSpeed) {
                fanSpeedID.map((iterator, index) => {
                    if (this.state.fanSpeed === iterator) {
                        console.log(fanSpeedID[index], index);
                        if (index === 3) {
                            speed = "FAN_SPEED_AUTO"
                        } else {
                            speed = fanSpeedID[index + 1]
                        }
                    }
                })
                this.setState({ fanSpeed: speed });
                this.props.sendCommand(
                    setFanSpeedToggle, this.props.guestDetail, "fanSpeed",
                    this.CommandCallBack, speed, this.props.selectedZone.zoneId
                );
                //this.VDAApiCall();
            }
        }
    }

    selectZone = (selectedZone, indexOfSelectedZone) => {
        console.log("selectedZone", selectedZone)
        if (selectedZone.zoneId) {
            let temp = parseInt(selectedZone.hvac.temperatureValue.slice(2, 4));
            let roomTemp = parseInt(selectedZone.hvac.currentRoomTemperature.slice(2, 4));
            this.props.setSelectedZone(selectedZone, roomTemp, indexOfSelectedZone);
            this.props.TempChange(null, temp);
        }
    }

    backButton = () => {
        let updateVDAZoneList = [...this.props.VDAZoneList]
        if (this.props.seletedIndex || this.props.seletedIndex === 0) {
            let updateZone = updateVDAZoneList[this.props.seletedIndex];
            let hvac = {
                temperatureValue: `+,${this.props.currentACTemp}.0`,
                currentRoomTemperature: `+,${this.props.currentRoomTemp}.0`,
                farenheitMax: updateZone.hvac.farenheitMax,
                fanSpeed: updateZone.hvac.fanSpeed,
                temperatureUnit: "C",
                mainSwitch: this.props.powerSwitch,
                acMode: updateZone.hvac.acMode,
                label: updateZone.hvac.label,
                ecoMode: updateZone.hvac.ecoMode,
                farenheitMin: updateZone.hvac.farenheitMin,
                celciusMax: updateZone.hvac.celciusMax,
                celciusMin: updateZone.hvac.celciusMin
            }
            // updateZone.hvac = hvac
            // updateVDAZoneList.splice(this.props.seletedIndex, 1);
            // console.log("new updateVDAZoneList", updateVDAZoneList);
            // updateVDAZoneList.push(updateZone);
            // console.log("updateVDAZoneList", updateVDAZoneList);
            // console.log("updateZone", updateZone);

            updateVDAZoneList.map((iterator, index) => {
                if (index === this.props.seletedIndex && iterator.zoneId === this.props.selectedZone.zoneId) {
                    updateVDAZoneList[this.props.seletedIndex].hvac = hvac
                }
            })
            console.log("new updateVDAZoneList", updateVDAZoneList);
        } else {
            console.log("seletedIndex is '", this.props.seletedIndex, "' and it is issue.")
        }
        this.props.restoreValue(updateVDAZoneList);
    }

    render() {
        let fanSpeedColor = {
            background: `${
                this.props.menuColor.assetBackgroundSelectorColor ?
                    this.props.menuColor.assetBackgroundSelectorColor : 'rgba(131, 171, 63, o.5)'}`,
            borderRadius: '9px',
            color: `${
                this.props.menuColor.assetFontSelectorColor ?
                    this.props.menuColor.assetFontSelectorColor : 'rgb(222, 235, 38)'}`
        }
        return (
            <div id="temp-selection" class="temp-selection tile-target"
                style={this.props.selectedZone.zoneId ? {} : { display: "none" }}>
                <button class="return-button"
                    data-target="ac-selection"
                    style={this.props.VDAZoneList.length === 1 || this.props.zoneCount === 1 ? { display: "none" } : {}}
                    onClick={() => { this.backButton("back") }}>Back to selection</button>
                {/* <h2>Temperature controls</h2> */}
                <div class="controls" style={{ position: "relative", marginTop: "1rem", color: "inherit" }} >
                    <p style={{ marginBottom: 0, marginRight: "1rem", marginTop: "0.75rem", display: "inline-block", color: "inherit" }}>
                        <strong style={{ color: "inherit" }}>Power</strong>
                    </p>
                    <label class="switch" style={{ position: "absolute" }}>
                        <input id="ac-power-switch" type="checkbox" checked={this.state.powerON === "ON" ? true : false} />
                        <span onClick={this.ACPowerSwitch} class="slider round"></span>
                    </label>
                </div>
                <div class="columns" style={{ marginBottom: "1rem", color: "inherit" }}>
                    <div class="col col-2" style={{ color: "inherit" }}>
                        <p
                            style={{ marginTop: "2rem", marginBottom: 0, color: "inherit" }}
                            className="center">
                            <strong style={{ color: "inherit" }}>SET TO</strong>
                        </p>
                        <p class="currentTemp separator" style={{ color: "inherit" }}>
                            {this.props.currentACTemp === 999 || this.state.powerON === "OFF" ? "--" : this.props.currentACTemp}
                            <sup style={{ color: "inherit" }}>
                                <i class="fa fa-circle-o" style={{ color: "inherit" }}></i>
                            </sup>
                        </p>
                    </div>
                    <div class="col col-2" style={{ color: "inherit" }}>
                        <p
                            style={{ marginTop: "2rem", marginBottom: 0, color: "inherit" }}
                            className="center"
                        >
                            <strong style={{ color: "inherit" }}>Current Temp.</strong>
                        </p>
                        <p class="currentTemp" style={{ color: "inherit" }}>
                            {this.props.currentRoomTemp === 999 ? "--" : this.props.currentRoomTemp}
                            <sup style={{ color: "inherit" }}>
                                <i class="fa fa-circle-o" style={{ color: "inherit" }}></i>
                            </sup>
                        </p>
                    </div>
                </div>
                <div class="controls" style={{ textAlign: "center" }}>
                    <a id="cooler"
                        onClick={() => { this.buttonClick("cooler", "tempControl") }}
                        class="button w-40">
                        <i class="fa fa-minus"></i>
                        Cooler
                    </a>
                    <a id="warmer"
                        onClick={() => { this.buttonClick("warmer", "tempControl") }}
                        class="button w-40"
                        style={{ marginLeft: "5px" }}>
                        <i class="fa fa-plus"></i>
                        Warmer
                    </a>
                </div>
                <p style={{ marginBottom: 0, color: "inherit" }}>
                    <strong style={{ color: "inherit" }}>Mode</strong>
                </p>
                <div class="controls" style={{ textAlign: "center" }}>
                    <a id="EcoMode"
                        onClick={() => { this.ecoButtonClick("EcoMode", "mode") }}
                        style={this.state.mode !== "EcoMode" ?
                            { color: "#ffffff" } : this.props.menuColor.assetFontSelectorColor ?
                                { color: this.props.menuColor.assetFontSelectorColor, background: "#666666" } : null}
                        class={`button ${this.state.mode === "EcoMode" ? "selected" : null} w-40`}
                    >
                        Eco Mode
                    </a>
                    {/* <a id="fanOnly"
                        onClick={() => { this.buttonClick("fanOnly", "mode") }}
                        class={`button ${this.state.mode === "fanOnly" ? "selected" : null} w-40`}>
                        Fan only
                    </a>
                    <a id="fanFixed"
                        onClick={() => { this.buttonClick("fanFixed", "mode") }}
                        class={`button ${this.state.mode === "fanFixed" ? "selected" : null} w-40`}
                        style={{ marginLeft: "5px" }}>
                        Fan fixed
                    </a>
                    <a
                        id="fanAuto"
                        onClick={() => { this.buttonClick("fanAuto", "mode") }}
                        class={`button ${this.state.mode === "fanAuto" ? "selected" : null} w-40`}>
                        Auto
                    </a>
                    <a id="fanOff"
                        onClick={() => { this.buttonClick("fanOff", "mode") }}
                        class={`button ${this.state.mode === "fanOff" ? "selected" : null} w-40`}
                        style={{ marginLeft: "5px" }}>
                        Off
                    </a> */}
                </div>
                <p style={{ marginBottom: 0, color: "inherit" }}>
                    <strong style={{ color: "inherit" }}>Fan Speed</strong>
                </p>
                <div class="controls" style={{ textAlign: "center", color: "inherit" }}>
                    {/* <a id="FAN_SPEED_AUTO"
                        onClick={() => { this.buttonClick("FAN_SPEED_AUTO", "fanSpeed") }}
                        class={`button ${this.state.fanSpeed === "FAN_SPEED_AUTO" ? "selected" : null} w-40`}>
                        Auto
                    </a>
                    <a id="FAN_SPEED_LOW"
                        onClick={() => { this.buttonClick("FAN_SPEED_LOW", "fanSpeed") }}
                        class={`button ${this.state.fanSpeed === "FAN_SPEED_LOW" ? "selected" : null} w-40`}
                        style={{ marginLeft: "5px" }}>
                        Low
                    </a>
                    <a id="FAN_SPEED_MED"
                        onClick={() => { this.buttonClick("FAN_SPEED_MED", "fanSpeed") }}
                        class={`button ${this.state.fanSpeed === "FAN_SPEED_MED" ? "selected" : null} w-40`}>
                        Medium
                    </a>
                    <a id="FAN_SPEED_HIGH"
                        onClick={() => { this.buttonClick("FAN_SPEED_HIGH", "fanSpeed") }}
                        class={`button ${this.state.fanSpeed === "FAN_SPEED_HIGH" ? "selected" : null} w-40`}
                        style={{ marginLeft: "5px" }}>
                        High
                    </a> */}
                    <label
                        id="FAN_SPEED_AUTO"
                        style={
                            this.state.fanSpeed === "FAN_SPEED_AUTO" ?
                                fanSpeedColor : { color: "inherit" }
                        }
                        className="w-40">
                        AUTO
                    </label>
                    <label
                        id="FAN_SPEED_LOW"
                        style={
                            this.state.fanSpeed === "FAN_SPEED_LOW" ?
                                fanSpeedColor : { color: "inherit" }
                        }
                        className="w-40">
                        LOW
                    </label>
                    <label
                        id="FAN_SPEED_MED"
                        style={
                            this.state.fanSpeed === "FAN_SPEED_MED" ?
                                fanSpeedColor : { color: "inherit" }
                        }
                        className="w-40">
                        MEDIUM
                    </label>
                    <label
                        id="FAN_SPEED_HIGH"
                        style={
                            this.state.fanSpeed === "FAN_SPEED_HIGH" ?
                                fanSpeedColor : { color: "inherit" }
                        }
                        className="w-40">
                        HIGH
                    </label>
                    <a id="ChangeFanSpeedButton"
                        onClick={() => { this.changeFanSpeed() }}
                        class='button w-70'>
                        Toggle Fan Speed
                    </a>
                </div>
                {/* <p style={{ marginBottom: 0 }}><strong>Unit</strong></p>
                <div class="controls" style={{ textAlign: "center" }}>
                    <a id="unitFarenheit"
                        onClick={() => { this.buttonClick("unitFarenheit", "unit") }}
                        class="button selected w-40">
                        Farenheit
                    </a>
                    <a id="unitCelsius"
                        onClick={() => { this.buttonClick("unitCelsius", "unit") }}
                        class="button w-40"
                        style={{ marginLeft: "5px" }}>
                        Celsius
                    </a>
                </div> */}
            </div >
        )
    }
}

const mapStateToProps = state => {
    return {
        currentControl: state.store.roomControl.currentControl,
        stringConst: state.store.home.stringConst,
        guestDetail: state.store.home.guestDetails,
        menuColor: state.store.home.MenuColor,
        currentACTemp: state.store.roomControl.ACControlStatus.currentACTemp,
        currentFanSpeed: state.store.roomControl.currentFanSpeed,
        powerSwitch: state.store.roomControl.powerSwitch,
        ecoMode: state.store.roomControl.ecoMode,
        celciusMax: state.store.roomControl.celciusMax,
        celciusMin: state.store.roomControl.celciusMin,
        currentRoomTemp: state.store.roomControl.currentRoomTemp,
        selectedZone: state.store.roomControl.selectedZone,
        VDAZoneList: state.store.roomControl.VDAZoneList,
        seletedIndex: state.store.roomControl.seletedIndex,
        zoneCount: state.store.roomControl.zoneCount
    }
}

export default connect(
    mapStateToProps,
    {
        sendCommand,
        sendACCommand,
        TempChange,
        popupOpenClose,
        setPowerSwitch,
        setEcoMode,
        VDAStatusApi,
        setSelectedZone,
        restoreValue
    }
)(ACControl);
